import styled from 'styled-components';

interface Props {
  hasErrorOnBirthDate: boolean;
}

export const Container = styled.div`
  display: flex;
  width: 85%;
  border-radius: 15px;
  max-width: 100rem;
  background: ${({ theme }) => theme.colors.background};
  padding: 1.5rem;

  @media (max-width: 900px) {
    padding: 1rem 1.5rem;
  }

  @media (max-width: 320px) {
    padding: 0.5rem;
  }
`;

export const Content = styled.div<Props>`
  display: flex;
  flex-direction: column;
  width: 100%;

  .contentDocument {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;

    p {
      display: flex;
      color: ${({ theme }) => theme.colors.secondary};
      font-size: 1.5rem;
      font-weight: 400;
      align-items: center;
    }

    .document {
      padding: 0.2rem 0;
      border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.text};
    }
  }

  .containerDataUser {
    margin: 1rem 0 0 0;

    p {
      display: flex;
      color: ${({ theme }) => theme.colors.secondary};
      font-size: 1.5rem;
      font-weight: 400;
      align-items: center;
    }

    display: flex;
    gap: 1.5rem;

    .contentData {
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: 0.2rem;
    }
  }
  .contentDocumentBirthDate {
    display: flex;
    width: 100%;
    max-width: 48rem;
    gap: 0.5rem;
    justify-content: space-between;
    .containerBirthDate {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;

      .MuiOutlinedInput-notchedOutline {
        border-color: ${({ theme, hasErrorOnBirthDate }) =>
          hasErrorOnBirthDate ? theme.colors.error : theme.colors.primary};
      }
      .MuiFormLabel-root {
        color: ${({ theme }) => theme.colors.secondary};
      }
    }
  }

  @media (max-width: 500px) {
    .containerDataUser {
      margin: 1.5rem 0 0 0;
      display: flex;
      flex-direction: column;
    }
  }
`;
